import { get } from 'lodash';

const styles = ({ color }) => ({
  content: {
    margin: 36,
    minHeight: 'calc(100vh - 125px)',
    backgroundColor: get(color, 'uiBackground'),
    marginTop: 0,
    padding: '24px 0px 36px 0px',
  },
  bodyContent: {
    marginTop: 10,
    display: 'block',
  },
  gridContainer: {
    display: 'inline-flex',
    width: 'auto',
    padding: '0 36px',
  },
  tabsContainer: {
    display: 'inline-flex',
  },
  divider: {
    backgroundColor: get(color, 'bodyText'),
  },
  notificationWidthClass: {
    width: '96%',
    padding: '0 15px',
    marginLeft: 0,
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/pages/Application/Details/styles.js